import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const deleteExpiringCredit = async (id: number): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation DeleteExpiringCredit($id: Float!) {
        deleteExpiringCredit(id: $id) {
          id
        }
      }
    `),
    variables: {
      id,
    },
  });

  return !!response.data?.deleteExpiringCredit;
};
